import { makeT } from "@lana-commerce/core/react/translateLocalStatic";

// prettier-ignore
export const T = makeT({
  ru: {
    "Craftwork. All right reserved. © 2021": "Crwaftwork. Все права защищены. © 2021",
    "Join our community": "Присоединяйтесь к нашему сообществу",
    Search: "Поиск",
    "Sign up and get 10% off your first order! You'll also gain exclusive access to product releases + more.": "Зарегистрируйтесь и получите 10% скидку на первый заказ! Вы также получите эксклюзивный доступ к выпускам продуктов + больше.",
  },
});
